import React from 'react';
import { X } from 'lucide-react';

// One door for "make something". The sidebar used to offer three separate
// entries (photo CTA, UGC, blank canvas); a seller thinking "I want a video"
// had to know our taxonomy first. Here the choice is stated in intentions.
// Handlers come in as props rather than via useShell() so this file has no
// import cycle with AppShell, which mounts it.
const tileCls =
  'flex w-full items-start gap-4 rounded-xl border border-[#2A2A30] bg-[#141417] p-5 text-left transition-colors hover:border-white/30';

function Tile({ emoji, title, blurb, onClick, testid }) {
  return (
    <button onClick={onClick} data-testid={testid} className={tileCls}>
      <span className="text-2xl leading-none">{emoji}</span>
      <span className="min-w-0">
        <span className="block font-medium text-white">{title}</span>
        <span className="mt-0.5 block text-xs text-white/45">{blurb}</span>
      </span>
    </button>
  );
}

export default function CreateMenu({ onClose, onPhoto, onUgc, onBlank, videoOn }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-4" onClick={onClose}>
      <div
        className="w-full max-w-md overflow-hidden rounded-2xl border border-[#2A2A30] bg-[#0E0E10]"
        onClick={(e) => e.stopPropagation()}
        data-testid="create-menu"
      >
        <div className="flex items-center justify-between border-b border-[#2A2A30] px-5 py-4">
          <div>
            <h2 className="text-base font-semibold text-white">What do you want to make?</h2>
            <p className="text-xs text-white/45">Pick one — everything else is already set.</p>
          </div>
          <button onClick={onClose} aria-label="Close" className="text-white/40 hover:text-white"><X size={18} /></button>
        </div>

        <div className="flex flex-col gap-2.5 p-5">
          <Tile
            emoji="📸" title="Photo session"
            blurb="Product shots, headshots, lifestyle…"
            onClick={onPhoto} testid="photo-recipes-open"
          />
          {videoOn && (
            <Tile
              emoji="🎬" title="UGC video"
              blurb="Short clips with a presenter"
              onClick={onUgc} testid="ugc-templates-open"
            />
          )}
          {/* PhotoRecipes has no initial-pillar prop, so this lands on the
              catalogue like the first tile; the wording still tells restorers
              they are in the right place. */}
          <Tile
            emoji="🔧" title="Restore &amp; fix"
            blurb="Old photos, comics, colour"
            onClick={onPhoto} testid="create-restore"
          />
        </div>

        <div className="border-t border-[#2A2A30] px-5 py-3.5">
          <button
            onClick={onBlank}
            data-testid="blank-canvas"
            className="text-xs text-white/40 transition-colors hover:text-white/70"
          >
            Start from a blank canvas →
          </button>
        </div>
      </div>
    </div>
  );
}
